(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_variant-b-product-enhance"] && !Shopify.designMode) return;
  try {
    (function () {

  /* ----------------------------------------------------
     Configuration
  ---------------------------------------------------- */

  const EASIFY_PLACEHOLDER_HINT = 'bijvoorbeeld';
  const EASIFY_LABEL_HINT = 'naam voor borduring';


  /*
    Visual screen approximations of the Brothread threads:
    Bruin       = 323
    Warm Goud   = 843
    Roze        = 079
    Blauw       = 017
    Wit         = 001
  */

  const EMB_COLORS = {
    'bruin': '#70452F',
    'warm goud': '#C9A15F',
    'roze': '#D79AAA',
    'blauw': '#8FBAD2',
    'wit': '#FFFFFF'
  };


  /* ----------------------------------------------------
     Helpers
  ---------------------------------------------------- */

  function normalise(value) {
    return (value || '')
      .trim()
      .toLowerCase();
  }


  function productFormScope() {
    return (
      document.querySelector('.product-details') ||
      document.querySelector('product-form') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document
    );
  }


  let KNOWN_CLOUD_SWATCHES = {};

  const swatchMapEl =
    document.querySelector('[data-vb-swatch-asset-map]');

  if (swatchMapEl) {
    try {
      KNOWN_CLOUD_SWATCHES =
        JSON.parse(swatchMapEl.textContent);
    } catch (error) {
      KNOWN_CLOUD_SWATCHES = {};
    }
  }


  function associatedLabel(input, group) {
    if (!input) return null;

    const labels =
      Array.from(group.querySelectorAll('label'));

    if (input.id) {
      const match =
        labels.find(
          (label) => label.htmlFor === input.id
        );

      if (match) return match;
    }

    return input.closest('label');
  }


  function lowestCommonParent(elements, stopAt) {
    if (!elements.length) return null;

    let candidate = elements[0].parentElement;

    while (
      candidate &&
      candidate !== stopAt &&
      !elements.every(
        (element) => candidate.contains(element)
      )
    ) {
      candidate = candidate.parentElement;
    }

    return candidate || stopAt || null;
  }


  /* ----------------------------------------------------
     Find Easify name field
  ---------------------------------------------------- */

  function findEasifyInput() {
    const scope = productFormScope();

    const byPlaceholder =
      Array.from(
        scope.querySelectorAll('input[placeholder]')
      ).find((input) =>
        input.placeholder
          .toLowerCase()
          .includes(EASIFY_PLACEHOLDER_HINT)
      );

    if (byPlaceholder) {
      return byPlaceholder;
    }


    const labels =
      Array.from(
        scope.querySelectorAll(
          'label, legend, div, span'
        )
      );

    const labelMatch =
      labels.find((element) =>
        element.textContent &&
        element.textContent
          .trim()
          .toLowerCase()
          .includes(EASIFY_LABEL_HINT)
      );


    if (labelMatch) {
      const wrap =
        labelMatch.closest('div') || scope;

      const input =
        wrap.querySelector(
          'input[type="text"], input[type="search"]'
        );

      if (input) {
        return input;
      }
    }

    return null;
  }


  /* ----------------------------------------------------
     Identify Kleur Wolk / Kleur Borduring groups
  ---------------------------------------------------- */

  function getOptionKind(group) {
    const explicitName =
      group.getAttribute('data-option-name') ||
      group.getAttribute('name') ||
      '';

    const titleEl =
      group.querySelector(
        [
          'legend',
          '.variant-option__name',
          '.variant-option__label',
          '.form__label',
          '[data-option-name]'
        ].join(',')
      );

    const title =
      normalise(
        explicitName ||
        (titleEl ? titleEl.textContent : '')
      );


    if (
      title.includes('kleur wolk') ||
      title === 'wolk kleur'
    ) {
      return 'cloud';
    }


    if (
      title.includes('kleur borduring') ||
      title.includes('borduurkleur') ||
      title.includes('borduring kleur')
    ) {
      return 'emb';
    }


    return null;
  }


  /* ----------------------------------------------------
     Update visual selected/disabled state
  ---------------------------------------------------- */

  function refreshSwatchState(label, input) {
    label.classList.toggle(
      'is-selected',
      Boolean(input.checked)
    );

    const disabled =
      input.disabled ||
      input.getAttribute('aria-disabled') === 'true';

    label.classList.toggle(
      'is-disabled',
      disabled
    );
  }


  /* ----------------------------------------------------
     Transform native Horizon buttons into Variant B swatches
  ---------------------------------------------------- */

  function captionSwatches() {
    const scope = productFormScope();


    /*
      Horizon versions can use slightly different wrappers.
      We intentionally support several possibilities.
    */

    const groups =
      Array.from(
        scope.querySelectorAll(
          [
            'fieldset',
            '.variant-option',
            'variant-option',
            '[data-option-name]'
          ].join(',')
        )
      );


    groups.forEach((group) => {
      const kind = getOptionKind(group);

      if (!kind) return;


      const inputs =
        Array.from(
          group.querySelectorAll(
            'input[type="radio"], input[type="checkbox"]'
          )
        );


      if (!inputs.length) return;


      const pairs =
        inputs
          .map((input) => ({
            input,
            label: associatedLabel(input, group)
          }))
          .filter((pair) => pair.label);


      if (!pairs.length) return;


      group.classList.add('vb-pd-swatch-group');


      /*
        Find the smallest common container containing all
        labels so the original 2-column Horizon layout can
        become a compact horizontal swatch rail.
      */

      const labels =
        pairs.map((pair) => pair.label);

      let row =
        group.querySelector(
          [
            '.variant-option__buttons',
            '.variant-option__values',
            '.variant-option__options',
            '[role="radiogroup"]'
          ].join(',')
        );


      if (
        !row ||
        !labels.every(
          (label) => row.contains(label)
        )
      ) {
        row =
          lowestCommonParent(
            labels,
            group
          );
      }


      if (row) {
        row.classList.add(
          'vb-pd-swatch-row'
        );

        if (row === group) {
          row.classList.add(
            'vb-pd-swatch-row--group'
          );
        }
      }


      pairs.forEach(({ input, label }) => {

        const valueName =
          (
            input.value ||
            input.getAttribute('aria-label') ||
            label.getAttribute('aria-label') ||
            label.textContent ||
            ''
          ).trim();


        if (!valueName) return;


        const key =
          normalise(valueName);


        label.classList.add(
          'vb-pd-swatch-label',
          `vb-pd-swatch-label--${kind}`
        );


        label.setAttribute(
          'data-vb-value',
          key
        );


        /*
          Add clean label beneath swatch.
        */

        let caption =
          label.querySelector(
            '.vb-pd-swatch-caption'
          );


        if (!caption) {
          caption =
            document.createElement('span');

          caption.className =
            'vb-pd-swatch-caption';

          label.appendChild(caption);
        }


        caption.textContent =
          valueName;


        /*
          STOFKLEUR:
          overlay corresponding real Mini Wolk photo.
        */

        if (
          kind === 'cloud' &&
          KNOWN_CLOUD_SWATCHES[key]
        ) {
          label.style.setProperty(
            '--vb-pd-swatch-image',
            `url('${KNOWN_CLOUD_SWATCHES[key]}')`
          );
        }


        /*
          BORDUURKLEUR:
          always use a solid colour.
          Never allow the brown Mini Wolk image to leak
          into the embroidery swatch.
        */

        if (
          kind === 'emb' &&
          EMB_COLORS[key]
        ) {
          label.style.setProperty(
            '--vb-pd-swatch-color',
            EMB_COLORS[key]
          );
        }


        refreshSwatchState(
          label,
          input
        );


        /*
          Re-sync selection after native Shopify radio change.
        */

        if (!input.dataset.vbSwatchWired) {
          input.dataset.vbSwatchWired =
            'true';


          input.addEventListener(
            'change',
            () => {
              pairs.forEach(
                (pair) =>
                  refreshSwatchState(
                    pair.label,
                    pair.input
                  )
              );
            }
          );
        }

      });

    });
  }


  /* ----------------------------------------------------
     Reactive "Jouw wolk voor Zoë"
  ---------------------------------------------------- */

  function updateHeading() {
    const heading =
      document.querySelector(
        '[data-vb-pd-heading]'
      );

    if (!heading) return;


    const input =
      findEasifyInput();


    const name =
      input
        ? input.value.trim()
        : '';


    heading.textContent =
      name
        ? `Jouw wolk voor ${name}`
        : 'Jouw wolk';
  }


  function wireEasifyInput() {
    const input =
      findEasifyInput();

    if (!input) return;
    const easifyWrap =
  input.closest('div[class]') ||
  input.parentElement;

if (easifyWrap) {
  easifyWrap.classList.add('vb-pd-easify-wrap');
}


    if (!input.dataset.vbWired) {
      input.dataset.vbWired =
        'true';


      input.addEventListener(
        'input',
        updateHeading
      );


      input.addEventListener(
        'focus',
        () => setStickyHidden(true)
      );


      input.addEventListener(
        'blur',
        () => setStickyHidden(false)
      );
    }


    /*
      Optional name hand-off from homepage:
      ?vb_name=Zoë
    */

    const params =
      new URLSearchParams(
        window.location.search
      );


    const vbName =
      params.get('vb_name');


    if (
      vbName &&
      !input.value
    ) {
      input.value =
        vbName;


      input.dispatchEvent(
        new Event(
          'input',
          { bubbles: true }
        )
      );


      params.delete('vb_name');


      const newQuery =
        params.toString();


      const newUrl =
        window.location.pathname +
        (newQuery
          ? `?${newQuery}`
          : '') +
        window.location.hash;


      window.history.replaceState(
        {},
        '',
        newUrl
      );
    }


    updateHeading();
  }


  /* ----------------------------------------------------
     Sticky mobile CTA
  ---------------------------------------------------- */

  function setStickyHidden(hidden) {
    const bar =
      document.querySelector(
        '[data-vb-sticky-atc]'
      );

    if (bar) {
      bar.classList.toggle(
        'is-hidden',
        hidden
      );
    }
  }


function wireStickyCta() {
  const btn = document.querySelector('[data-vb-sticky-btn]');

  if (!btn || btn.dataset.vbWired) {
    return;
  }

  btn.dataset.vbWired = 'true';

  btn.addEventListener('click', (event) => {
    event.preventDefault();

    /* Eerst Easify controleren */
    const input = findEasifyInput();

    if (input && input.value.trim().length < 2) {
      input.focus();

      input.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      return;
    }

    /*
      Blijf binnen de huidige productinformatie,
      zodat we nooit per ongeluk een andere koopknop vinden.
    */
    const enhanceRoot =
      document.querySelector('[data-vb-pd-root]');

    const productDetails =
      enhanceRoot?.closest('.product-details') ||
      enhanceRoot?.closest('[data-product-details]') ||
      document.querySelector('.product-details') ||
      document;

    /*
      Zoek de echte Horizon add-to-cart button.
    */
    const candidates = Array.from(
      productDetails.querySelectorAll(
        [
          '[ref="addToCartButton"]',
          'button[name="add"]',
          'button[type="submit"]',
          'input[type="submit"]'
        ].join(',')
      )
    );

    const realBtn = candidates.find((button) => {
      if (button === btn) return false;
      if (button.disabled) return false;

      const text = (
        button.textContent ||
        button.value ||
        ''
      ).trim().toLowerCase();

      return (
        text.includes('winkelwagen') ||
        text.includes('toevoegen') ||
        text.includes('add to cart') ||
        button.getAttribute('name') === 'add' ||
        button.getAttribute('ref') === 'addToCartButton'
      );
    });

    if (realBtn) {
      realBtn.click();
      return;
    }

    /*
      Fallback:
      submit het echte Shopify-productformulier.
      requestSubmit laat normale Shopify/Easify-validatie
      gewoon uitvoeren.
    */
    const form =
      productDetails.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(
          new Event('submit', {
            bubbles: true,
            cancelable: true
          })
        );
      }
    }
  });
}


  /* ----------------------------------------------------
     Keep sticky price equal to the real native price
  ---------------------------------------------------- */

  function syncStickyPriceFromDom() {
    const priceEl =
      document.querySelector(
        '.product-details .price'
      ) ||
      document.querySelector(
        '.price'
      );


    const stickyEl =
      document.querySelector(
        '[data-vb-sticky-price]'
      );


    if (
      priceEl &&
      stickyEl
    ) {
      const text =
        priceEl.textContent.trim();


      if (text) {
        stickyEl.textContent =
          text;
      }
    }
  }


  /* ----------------------------------------------------
     Init
  ---------------------------------------------------- */

  function init() {
    captionSwatches();
    wireEasifyInput();
    wireStickyCta();
    syncStickyPriceFromDom();
  }


  /*
    Works both on a normal storefront page and inside
    Shopify's Theme Editor.
  */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }


  /*
    Horizon morphs the product DOM whenever a variant changes.
  */

  document.addEventListener(
    'variant:update',
    () => {

      captionSwatches();
      wireEasifyInput();
      updateHeading();

      requestAnimationFrame(
        syncStickyPriceFromDom
      );

      setTimeout(
        syncStickyPriceFromDom,
        150
      );
    }
  );


  /*
    Theme Editor can reload the section dynamically.
  */

  document.addEventListener(
    'shopify:section:load',
    () => {
      setTimeout(
        init,
        30
      );
    }
  );


  /*
    Easify can inject its field after the native product
    markup has already loaded. Observe child insertions so
    the heading can still attach automatically.
  */

  const observeTarget =
    document.querySelector(
      '.product-details'
    );


  if (
    observeTarget &&
    !window.__vbProductObserver
  ) {
    let observerTimer;


    window.__vbProductObserver =
      new MutationObserver(() => {

        clearTimeout(
          observerTimer
        );


        observerTimer =
          setTimeout(
            init,
            60
          );

      });


    window.__vbProductObserver.observe(
      observeTarget,
      {
        childList: true,
        subtree: true
      }
    );
  }

})();
  } catch(e) { console.error(e); }
})();

})();
